import { render, staticRenderFns } from "./CoinStore.vue?vue&type=template&id=efc58332&scoped=true&"
import script from "./CoinStore.vue?vue&type=script&lang=ts&"
export * from "./CoinStore.vue?vue&type=script&lang=ts&"
import style0 from "./CoinStore.vue?vue&type=style&index=0&id=efc58332&lang=sass&scoped=true&"
import style1 from "./CoinStore.vue?vue&type=style&index=1&id=efc58332&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efc58332",
  null
  
)

export default component.exports